import { Cluster, type ClusterProps } from '@src/components/Cluster/Cluster';

export type BarProps = Omit<ClusterProps, 'justify'>;

/**
 * A Cluster that pushes its ends apart — a title on the left, actions on the
 * right. Wrapping is still allowed, so a narrow screen stacks rather than
 * overflows.
 */
export function Bar({ gap = 4, wide = true, ...rest }: BarProps) {
  return <Cluster justify="between" gap={gap} wide={wide} {...rest} />;
}
